import { render, staticRenderFns } from "./login-form.vue?vue&type=template&id=c35b3090&"
import script from "./login-form.vue?vue&type=script&lang=js&"
export * from "./login-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports